<template>
  <div>
    <b-modal
      :hide-header="true"
      :hide-footer="true"
      content-class="modal-blue"
      id="new-graduation-survey-modal"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
      size="xl">
      <!-- Modal content -->
        
      
      <div v-if="$i18n.locale=='ka'" v-html="newGraduSurvey[0].text"></div>
      <div v-else v-html="newGraduSurvey[0].text_eng"></div>
      <br>
      <br>
      <br>
        
      <div class="row text-white content">

                    <div class="col-12">   {{$t('graduation.question')}}  </div>


                     <div class="col-12">   <input type="radio"  name="type" id="yes" class="radio" @click="chosenAnswer(1)"  />-  {{$t('graduation.yes')}} </div>  
                     <div class="col-12">  <input type="radio"  name="type" id="no" class="radio"  @click="chosenAnswer(0)"  />-  {{$t('graduation.no')}} </div>
                      




      </div>
    </b-modal>

  </div>
</template>

<script>
 

export default {

    props:['newGraduSurvey'],

            methods:{

                    chosenAnswer(answer){

                                if(confirm("ნამდვილად გსურთ არჩეული პასუხის შენახვა?/Are you sure you want to save the selected answer?")){

                                        this.$store.dispatch('auth/saveGraduAnswer',{answer:answer}).then(response=>{

                                               window.location.href='/'


                                        })


                                }    


                    }


            }


   
};
</script>

<style scoped>
.radio{
 height: 20px;
  width: 20px;
    

}

</style>
 